import { translateLang } from '@/data/i18n/translateLang'
import { computed } from 'vue'

/** 其他操作选项 */
export const otherOperate = [
  {
    text: 'printPage.leftAlign',
    type: 'leftAlign',
    isDisable(num: number) {
      return num <= 1
    },
  },
  {
    text: 'printPage.rightAlign',
    type: 'rightAlign',
    isDisable(num: number) {
      return num <= 1
    },
  },
  {
    text: 'printPage.topAlign',
    type: 'topAlign',
    isDisable(num: number) {
      return num <= 1
    },
  },
  {
    text: 'printPage.bottomAlign',
    type: 'bottomAlign',
    isDisable(num: number) {
      return num <= 1
    },
  },
  {
    text: 'printPage.horizontalAlign',
    type: 'horizontalAlign',
    isDisable(num: number) {
      return num <= 1
    },
  },
  {
    text: 'printPage.verticalAlign',
    type: 'verticalAlign',
    isDisable(num: number) {
      return num <= 1
    },
  },
  {
    text: 'printPage.horizontalSplit',
    type: 'horizontalSplit',
    isDisable(num: number) {
      return num <= 2
    },
  },
  {
    text: 'printPage.verticalSplit',
    type: 'verticalSplit',
    isDisable(num: number) {
      return num <= 2
    },
  },
]

/**
 * @description 双语标签可选项
 */
export function getDualLanguageOptions() {
  return [
    {
      label: translateLang('房间'),
      value: 'roomName',
    },
    {
      label: translateLang('板件名'),
      value: 'partName',
    },
    {
      label: translateLang('柜体'),
      value: 'loc',
    },
  ]
}

export const dualLanguageOptions = computed(() => getDualLanguageOptions())
